/**
 * @module utils/validation
 * @description Funciones de validación de datos en el sistema ACSGC.
 */

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Verifica si un string es un UUID v4 válido (formato PostgreSQL).
 * Acepta null/undefined y retorna false sin lanzar excepción.
 *
 * @param value - Valor a validar
 * @returns true si cumple el patrón UUID, false en cualquier otro caso
 */
export function isValidUUID(value: string | null | undefined): boolean {
  if (!value) return false;
  return UUID_REGEX.test(value);
}
